import {
  IMasterclassDescription,
  IMasterClassKeyFactors,
} from '@/interfaces/masterclassDescription';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { Container, Typography } from '@pwskills/rachnaui';
import { useRouter } from 'next/router';

const MetaSection = () => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );
  const masterClassKeyFactors = masterclassDetails?.masterclassKeyFactors || [];
  const router = useRouter();
  const isDashBoard = router.pathname.includes('/dashboard');
  return (
    <div className={`${isDashBoard ? '' : 'bg-blue-50'} w-full`}>
      <Container
        id="category-hero-section"
        className={`${
          isDashBoard
            ? 'medium:!pt-9 medium:!pb-6 px-4 large:!px-8 small:!pt-6'
            : '!py-8 medium:!py-14 large:!pt-14 large:!pb-[72px] flex flex-col !px-4 medium:!px-8 large:!px-20'
        }`}
      >
        <div
          className={`${
            isDashBoard
              ? 'grid grid-cols-1 medium:grid-cols-4 large:grid-cols-4 gap-3 medium:gap-4 large:gap-6'
              : 'flex flex-row gap-3 medium:gap-4 large:gap-6 flex-wrap'
          }`}
        >
          {masterClassKeyFactors?.map((meta: IMasterClassKeyFactors) => {
            return (
              <div
                className={`flex flex-col gap-2 ${
                  isDashBoard ? 'w-full' : 'w-full medium:!w-[48%] large:!w-[24.1%]'
                }`}
                key={meta._id}
              >
                <div className="p-1 bg-white w-[56px] h-[56px] rounded-lg border border-solid border-stroke-200">
                  <img src={meta.image} alt="img" className="w-full h-full" />
                </div>
                <Typography component={isDashBoard ? 'body-regular' : 'subheading'} variant="bold">
                  {meta.title}
                </Typography>
                <Typography
                  component="body-regular"
                  variant="regular"
                  className="text-gray-850 !text-[16px] !leading-[24px]"
                >
                  {meta.description}
                </Typography>
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default MetaSection;
